/**
 * User Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GroupApplicationModel { 
    groupApplicationId?: number;
    applicationSettingId?: number;
    applicationId?: number | null;
    organizationApplicationId?: string | null;
    applicationName?: string | null;
    groupId?: number;
    groupAttributes?: string | null;
    isActive?: boolean;
}

